/* Publish by EComposer at 2026-10-20 01:47:54*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oqz5cfxowg"]=  window.__ectimmers["ecom-oqz5cfxowg"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-oqz5cfxowg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqz5cfxowg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zhipu7vraj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zhipu7vraj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8kpklgfyk1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8kpklgfyk1r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-olfdcdxl4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-olfdcdxl4b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9tedt37ne3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tedt37ne3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jcucrh2u0bl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jcucrh2u0bl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97kjck4afgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97kjck4afgn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9dz8kljnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9dz8kljnc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hijka0s7yls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hijka0s7yls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-187emhf2b6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-187emhf2b6p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xu3hbfq20e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xu3hbfq20e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5f5rsacsp9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5f5rsacsp9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyv4j6u6hp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyv4j6u6hp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9h6py6lt03l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h6py6lt03l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-na7ft201fw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-na7ft201fw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fo6pz9m0c24').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fo6pz9m0c24', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emjszrwtal7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emjszrwtal7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9b5mu7yut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9b5mu7yut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkt00jj7hfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkt00jj7hfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ed83ugtjdfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed83ugtjdfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khwjv8cj1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khwjv8cj1u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z7psw9plxvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z7psw9plxvi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1d30rjtr1g3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d30rjtr1g3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ajfopnrmvnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ajfopnrmvnq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6f96idp7ycl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6f96idp7ycl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1y5s2fyzysc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1y5s2fyzysc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ii4of5xetk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ii4of5xetk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-otkhevziemq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-otkhevziemq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwc44b83x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwc44b83x3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2hu5o7uy58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2hu5o7uy58', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eigpvlnwylg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eigpvlnwylg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yyademz5x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yyademz5x3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yzrgpnwobf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yzrgpnwobf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6nmb6hyajd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6nmb6hyajd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46mg4xwvos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46mg4xwvos', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cf2xba19b5a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cf2xba19b5a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6c2tnb9e545').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6c2tnb9e545', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghyq01e3pa7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghyq01e3pa7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vr72fqqme5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vr72fqqme5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aw0flnlqud4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw0flnlqud4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8zkn3772nr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8zkn3772nr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3avypcoqhli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3avypcoqhli', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zyljp2jyjpr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zyljp2jyjpr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mo0tpy4yn3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mo0tpy4yn3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19schoqy91q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19schoqy91q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vh0aki44h29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vh0aki44h29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-68f645m1a7x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-68f645m1a7x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1lephul6c9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1lephul6c9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn6y1f7ybut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn6y1f7ybut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llwyirhegqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llwyirhegqh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lb8r2r6469').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lb8r2r6469', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j680n1pgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j680n1pgn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lizka441jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lizka441jc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmh3gpa8st').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmh3gpa8st', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umxjsh8wn6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umxjsh8wn6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qc4rz98qrvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qc4rz98qrvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cd3jov82y5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cd3jov82y5b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcl3xyyaxra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcl3xyyaxra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffl9na0zhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffl9na0zhs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4yuuytu6d2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4yuuytu6d2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0st36aytc63').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0st36aytc63', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-febzcoasrq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-febzcoasrq6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lq9zqukszqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lq9zqukszqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-56yh5ay73t3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-56yh5ay73t3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2erz80lk18y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2erz80lk18y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4l37305m5ir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4l37305m5ir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4cfylrhxext').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4cfylrhxext', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8u1820ue7e4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8u1820ue7e4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8lx6q6u373x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8lx6q6u373x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4il0n801y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4il0n801y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qf4dus4nv7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qf4dus4nv7r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-al6saxyohgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-al6saxyohgj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ad4b60xefjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ad4b60xefjr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xi912houpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xi912houpg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ac9kpjcjagt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ac9kpjcjagt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqu1pcq7jf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqu1pcq7jf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7pblzyaaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7pblzyaaj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xk2fx4zc4qi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk2fx4zc4qi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-972ob4vb38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-972ob4vb38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wdlz8u9io6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wdlz8u9io6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28ba9btvvcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28ba9btvvcq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xqoq024acvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xqoq024acvf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6zu7990319').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6zu7990319', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cupg6lnxnst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cupg6lnxnst', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8d36q2wcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8d36q2wcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1meh4d8mw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1meh4d8mw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkj5efsyww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkj5efsyww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6dh8m7f05').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6dh8m7f05', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0s43egp676uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0s43egp676uj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xaxant65rd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xaxant65rd9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmcalbcot4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmcalbcot4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tim19cokhil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tim19cokhil', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmx4aemd3qi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmx4aemd3qi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2zspyvued6g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2zspyvued6g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okhpvuui3pj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okhpvuui3pj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1q13gf13ac7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1q13gf13ac7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjx28kw8ko8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjx28kw8ko8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd3nv2n2tg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd3nv2n2tg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aq56w0mbppb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aq56w0mbppb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp9a1z79xlj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp9a1z79xlj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puuj5gb05k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puuj5gb05k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8ps20htf2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8ps20htf2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrxw2dw98r9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrxw2dw98r9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yhpxpv7dw4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yhpxpv7dw4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lfdftp2t9kg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lfdftp2t9kg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2651em4hq9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2651em4hq9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mwenmmnrlfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mwenmmnrlfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ormdajg2um').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ormdajg2um', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ciz1o5p3d3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ciz1o5p3d3m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2j3i1ngkm9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j3i1ngkm9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iz0t9pbr97q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iz0t9pbr97q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rtgp2aquq7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rtgp2aquq7f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lkll2h7yjhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lkll2h7yjhr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1mtyko3lkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1mtyko3lkh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qovgyrtvkhq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qovgyrtvkhq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ho6o4z9mrri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ho6o4z9mrri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4epmra7tvba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4epmra7tvba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dg9a8nuv5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dg9a8nuv5o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5hxb8i0hoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5hxb8i0hoi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a4fb8q4ectt"]=  window.__ectimmers["ecom-a4fb8q4ectt"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-a4fb8q4ectt"]["4ffnh3ysa"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-a4fb8q4ectt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4fb8q4ectt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fj21hrldhf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fj21hrldhf8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nfwkbg3na2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nfwkbg3na2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uj0gos48cjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uj0gos48cjs', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2fde42evlul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2fde42evlul', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71fu50lf375').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71fu50lf375', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6poo7qb8417').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6poo7qb8417', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-viuvpv268v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-viuvpv268v', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1rmcl0amf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1rmcl0amf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-krouf9i80kh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-krouf9i80kh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhf1u0keu9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhf1u0keu9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hayostw3y97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hayostw3y97', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfiice44o9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfiice44o9h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q349u2ebird').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q349u2ebird', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpvfz5vi3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpvfz5vi3c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7niea72qm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7niea72qm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1oy0tbm5pbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1oy0tbm5pbj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynbbovgk8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynbbovgk8g', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pl58ck866d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pl58ck866d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmo84rsm73j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmo84rsm73j', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tel2xxvflae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tel2xxvflae', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5d3le3y4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5d3le3y4b', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45hf3r4srb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45hf3r4srb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tagdaugekl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tagdaugekl', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5aefm42no').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5aefm42no', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cn80puwdt6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cn80puwdt6v', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6xuxvbazulw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6xuxvbazulw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55rbbsyuyud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55rbbsyuyud', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mquaqk71kh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mquaqk71kh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ygyzsvl1v2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ygyzsvl1v2r', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xc3srde2ebq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xc3srde2ebq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8v6sgw02kcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8v6sgw02kcg', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzab9gmy51l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzab9gmy51l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7sbrhmsuy9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7sbrhmsuy9p', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsuvn3mcu6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsuvn3mcu6q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l20c100xbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l20c100xbw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hg2xji94nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hg2xji94nb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jotop40fwbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jotop40fwbm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s03yx4rff4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s03yx4rff4l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3u6xxwux0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3u6xxwux0a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-odggi1vys9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-odggi1vys9e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hcnu7cang2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hcnu7cang2j', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9o4ve1erk36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9o4ve1erk36', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v3ihp2z4e6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v3ihp2z4e6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edklmjwvdyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edklmjwvdyn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iowe4cky6ok').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iowe4cky6ok', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yx3o6edtwcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yx3o6edtwcr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbk8ui9dlso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbk8ui9dlso', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yerehb3bf1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yerehb3bf1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3759jr351').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3759jr351', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idmag7etebn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idmag7etebn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eq2p6ibvhvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eq2p6ibvhvb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ez9a8hnf8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ez9a8hnf8o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1rl91820ls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1rl91820ls', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-weyw5cfmnfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-weyw5cfmnfl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3w0twg2iv92').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3w0twg2iv92', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9v8m3ct26e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9v8m3ct26e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-183gzrlk6yq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-183gzrlk6yq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avbvtf59tan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avbvtf59tan', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pruv8xdt91k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pruv8xdt91k', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ib3hsnc5hvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ib3hsnc5hvn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i82zxbs443d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i82zxbs443d', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hv08kq3j62').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hv08kq3j62', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-010zatg27m5nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-010zatg27m5nb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lyap8ik5axl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lyap8ik5axl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptmoec5qssf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptmoec5qssf', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjvdciq6g1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjvdciq6g1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqn38asex1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqn38asex1e', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcgcizva5do').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcgcizva5do', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w7w9eq4ifje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7w9eq4ifje', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pujqcderc6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pujqcderc6p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cre6fuyh3s4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cre6fuyh3s4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lp28jem85vq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lp28jem85vq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9n61fxxzur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9n61fxxzur', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8oxlfrc0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8oxlfrc0e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cnxotwsuj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cnxotwsuj3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dqcvbnbg56w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dqcvbnbg56w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmdiuoob1xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmdiuoob1xo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nds102h34o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nds102h34o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqi27en9yut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqi27en9yut', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qrbcnyeu7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qrbcnyeu7e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1jlxj9zqnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1jlxj9zqnh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewe3w2xu53').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewe3w2xu53', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-un7c0cfa9k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-un7c0cfa9k8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqjpnynigzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqjpnynigzj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2tx93b3rt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2tx93b3rt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ui2mj0zd5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ui2mj0zd5i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2tpwvtclqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2tpwvtclqn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l249gdq7l9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l249gdq7l9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0gj07ymgvgzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gj07ymgvgzh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1p6f7t0gdzd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1p6f7t0gdzd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdwq13cf2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdwq13cf2a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6o9x2rzusg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6o9x2rzusg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ioprg8ztvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ioprg8ztvg', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12knimuabgob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12knimuabgob', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8228bvrx6rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8228bvrx6rq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tf3zsx9ts9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tf3zsx9ts9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8dz3jkdm2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8dz3jkdm2i', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8mch482t2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8mch482t2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hras4oxz7xf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hras4oxz7xf', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}